import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SearchService } from '@sparro/app/core/api/search/search.service';
import { FormControl, FormGroup } from '@angular/forms';
import _ from 'lodash';

@Component({
  selector: 'uni-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  @Input() searchType: string = '';
  @Input() showOptions: boolean = false;
  @Input() placeholder: string = null;
  @Input() orderTitle: string = null;
  @Output() filter = new EventEmitter<any>();
  @Output() sort = new EventEmitter<any>();
  @Output() searchedText = new EventEmitter<any>();
  host: string='';
  imageWidth: number = null;
  
  bulletin: any;
  searchfield: FormGroup;

  constructor(
    private searchService: SearchService
  ) { 
    this.imageWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.host = this.placeholder.includes('Publications') ? 'publication_search' : 
    this.placeholder.includes('Journals') ? 'journal_search' : 
    this.placeholder.includes('Competitions') ? 'competition_search' : 'project_search';
    this.searchfield = new FormGroup({
      search: new FormControl('')
    });
    this.searchService.getBulletins(this.host).subscribe(response => {
      if (response) {
        this.bulletin = _.shuffle(response)[0];
      }
    }, err => {
      console.log(err);
    })
    console.log(this.host);
  }

  toggleFilter() {
    this.filter.emit();
  }

  toggleSort() {
    this.sort.emit(true);
  }

  onSubmit(): void {
    this.searchedText.emit(this.searchfield.value.search);
    this.searchfield.reset();
  }
}
